// extracted by mini-css-extract-plugin
export default {"RedGradientAlert":"RedGradientAlert_RedGradientAlert__nS09Z","withInteractionEffect":"RedGradientAlert_withInteractionEffect__HG++f"};